import { IOdataField } from './IOdataField';

export class OdataFieldString implements IOdataField {
  private value: string;

  constructor(value: string) {
    this.value = value;
  }

  toFieldString() {
    // escape single quotes
    this.value = this.value.replace(/'/g, "''");

    return `'${encodeURIComponent(this.value)}'`;
  };
}
